import { DATA_COUNT_OPTIONS } from "../../../constants";

const DataLimitFilter = ({ tableDataLimit, handleOnChange }) => (
  <div className="w-full h-full bg-gray-900 flex items-center p-2">
    <select
      value={tableDataLimit}
      onChange={handleOnChange}
      className="pl-4 text-sm bg-gray-900 text-gray-600 font-bold border-1 border-gray-600 rounded-2xl mx-2 py-0 cursor-pointer"
    >
      {DATA_COUNT_OPTIONS.map((value) => (
        <option
          key={value}
          value={value}
          className="bg-gray-800 py-0 pl-4 text-white"
        >
          {`Range ${value}`}
        </option>
      ))}
    </select>
  </div>
);

export default DataLimitFilter;
